export const generatorHelpKey = {entity: 'NETFORM', key: 5};
